module.exports = __webpack_public_path__ + "static/media/C2QB_green.c44cb194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/C2QB_green.png
// module id = 2429
// module chunks = 0